import React from 'react'

import { TExtendsHTMLElement } from '../../../types/shared'
import './index.scss'

interface ILabelBadgeProps {
  label: string | number
}

const LabelBadge: React.FC<TExtendsHTMLElement<ILabelBadgeProps>> = (props) => {
  return (
    <div className='count'>
      {props.label}
    </div>
  )
}

export {
  LabelBadge
}
